import React, { forwardRef, memo } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const IconHeadingTwo = memo(
  forwardRef((props, ref) => (
    <SvgIcon
      {...props}
      ref={ref}
      viewBox="0 0 24 24"
    >
      <path
        d="M10.5625 11.1367V12.0566H5.94531V11.1367H10.5625ZM6.12109 7.46875V16H4.99023V7.46875H6.12109ZM11.5469 7.46875V16H10.4219V7.46875H11.5469ZM18.8652 15.1094V16H13.2812V15.2207L16.0762 12.1094C16.4199 11.7266 16.6855 11.4023 16.873 11.1367C17.0645 10.8672 17.1973 10.627 17.2715 10.416C17.3496 10.2012 17.3887 9.98242 17.3887 9.75977C17.3887 9.47852 17.3301 9.22461 17.2129 8.99805C17.0996 8.76758 16.9316 8.58398 16.709 8.44727C16.4863 8.31055 16.2168 8.24219 15.9004 8.24219C15.5215 8.24219 15.2051 8.31641 14.9512 8.46484C14.7012 8.60938 14.5137 8.8125 14.3887 9.07422C14.2637 9.33594 14.2012 9.63672 14.2012 9.97656H13.1172C13.1172 9.49609 13.2227 9.05664 13.4336 8.6582C13.6445 8.25977 13.957 7.94336 14.3711 7.70898C14.7852 7.4707 15.2949 7.35156 15.9004 7.35156C16.4395 7.35156 16.9004 7.44727 17.2832 7.63867C17.666 7.82617 17.959 8.0918 18.1621 8.43555C18.3691 8.77539 18.4727 9.17383 18.4727 9.63086C18.4727 9.88086 18.4297 10.1348 18.3438 10.3926C18.2617 10.6465 18.1465 10.9004 17.998 11.1543C17.8535 11.4082 17.6836 11.6582 17.4883 11.9043C17.2969 12.1504 17.0918 12.3926 16.873 12.6309L14.5879 15.1094H18.8652Z"
        fill="currentColor"
      />
    </SvgIcon>
  ))
);

IconHeadingTwo.displayName = 'IconHeadingTwo';
